import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import { SxProps, Theme } from '@mui/material/styles'

import JNotificationBanner from '@/components/atoms/JNotificationBanner'
import { useLoading } from '@/context/LoadingContext'
import { memo } from 'react'
import ApplicationBar from '../AppBar'

interface ILayoutProps {
  children?: React.ReactNode
  sx?: SxProps<Theme>
  skipBottomBar?: boolean
  withSideBar?: boolean
  noPadding?: boolean
}

export const pageLayoutBodyClass = 'body_layout'

const MemoizedApplicationBar = memo(ApplicationBar)

const Layout: React.FC<ILayoutProps> = ({
  children,
  sx,
  skipBottomBar,
  withSideBar = false,
  noPadding = false,
}: ILayoutProps) => {
  const { isLoading } = useLoading()

  return (
    <Box className="root_layout">
      <MemoizedApplicationBar skipBottomBar={skipBottomBar} />
      <Box
        className={pageLayoutBodyClass}
        sx={{
          overflowY: 'auto',
          overflowX: 'hidden',
          backgroundColor: theme => theme.palette.background.page,
          height: '100dvh',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        <JNotificationBanner />
        {isLoading && (
          <LinearProgress
            color="success"
            sx={{
              width: '100%',
              position: 'relative',
              zIndex: 9999,
            }}
          />
        )}
        {noPadding ? (
          <Box sx={Array.isArray(sx) ? sx : [sx]}>{children}</Box>
        ) : (
          <Box
            sx={{
              pr: { md: 3 },
              pl: !withSideBar ? { md: 3 } : 0,
              pt: !withSideBar ? { xs: 3, md: 5 } : 0,
            }}
          >
            <Box sx={Array.isArray(sx) ? sx : [sx]}>{children}</Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Layout
